export default "__VITE_ASSET__CMq6yvfq__"